import styles from "./buttons.module.css"
import React from "react"
import cx from "classnames"
import {BzIconPro} from "story/components/typography"

export const getButtonClass = (selected, active) => (!active && !selected ? "disabled" : selected ? "selected" : "")

const baseUrl = "https://static-app-misc.teachbanzai.com/img/"

const pictureChildren = ({imageFileNames}, links, children) => {
  const idx = links.findIndex(([title, _]) => title === children) // find the link for this particular button
  const [linkId, _] = links[idx]

  return [<span className={styles["picture-copy"]}>{children}</span>, <img className={styles["picture"]} src={`${baseUrl}${imageFileNames[linkId]}`} />]
}

export const Button = ({
  onClick,
  children,
  className,
  inlineStyles,
  customStyles,
  disabled = false,
  isComplete = false,
  onMouseEnter,
  onMouseLeave,
  style,
  styleOptions,
  links
}) => {
  const nodeStyle = style

  return (
    <button
      type="button"
      style={inlineStyles}
      className={cx(className && styles[className], nodeStyle && styles[nodeStyle], disabled && styles["disabled"], styles["default"], customStyles)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
      disabled={disabled || isComplete}
    >
      {nodeStyle === "with-picture" ? pictureChildren(styleOptions, links, children) : children}
    </button>
  )
}

export const LinkButton = ({isComplete = false, children, href, disabled = false, className, customStyles}) => (
  <a className={cx(styles["filled"], isComplete && styles["is-complete"], disabled && styles["disabled-filled"], styles[className], customStyles)} href={href} target="_blank">
    {children}
  </a>
)

export const ConfirmButton = ({onClick, children, className = "filled", disabled = false, isComplete = false, customStyles}) => {
  return (
    <button
      className={cx(isComplete && styles["is-complete"], disabled && styles["disabled-filled"], styles[className], customStyles)}
      onClick={onClick}
      disabled={disabled || isComplete}
    >
      {children}
    </button>
  )
}

export const TableButton = ({onClick, children, className = "filled", disabled = false, isComplete = false}) => (
  <button className={cx(isComplete && styles["is-complete"], disabled && styles["disabled-table"], styles[className])} onClick={onClick} disabled={disabled || isComplete}>
    {children}
  </button>
)

export const IgnitionButton = ({onClick, children, inlineStyles}) => (
  <Button className="ignition" inlineStyles={inlineStyles} onClick={onClick}>
    {children}
  </Button>
)

export const UndoButton = ({index, className = "undo", onClick, disabled, scrollRef}) => (
  <div className={cx(styles[className], disabled && styles["disabled-undo"])}>
    <button onClick={disabled ? null : () => onClick(index, scrollRef)} disabled={disabled}>
      <BzIconPro className="bz-undo" />
      Undo
    </button>
  </div>
)

export const LabelButton = ({onClick, children}) => (
  <button className={styles["label"]} onClick={onClick}>
    {children}
  </button>
)

export const WidgetButton = ({onClick, disabled, customStyles, inlineStyles, children}) => {
  return (
    <Button inlineStyles={inlineStyles} customStyles={customStyles} className={styles["widget"]} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  )
}

export const FilledButton = ({onClick, disabled, customStyles, inlineStyles, children}) => {
  return (
    <Button inlineStyles={inlineStyles} customStyles={customStyles} className={"round-filled"} disabled={disabled} onClick={onClick}>
      {children}
    </Button>
  )
}

export const BorderedButton = ({onClick, disabled, customStyles, inlineStyles, children}) => (
  <Button inlineStyles={inlineStyles} customStyles={customStyles} className={"bordered"} disabled={disabled} onClick={onClick}>
    {children}
  </Button>
)
